<template>
  <div class="Navigation">
    <van-popup
      v-model="show"
      position="bottom"
      round
      :style="{ height: '350px' }"
      @click-overlay="onCancel"
      @close="onCancel"
    >
      <van-picker show-toolbar :columns="columns" @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
import { openMap } from '@/utils/utils'
export default {
  name: 'Navigation',
  props: {
    showKey: {
      type: Boolean,
      default: false,
    },
    dhObj: {
      type: Object,
      default: null,
    },
  },
  watch: {
    showKey: {
      handler(val) {
        this.show = val
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      show: false,
      value: '',
      columns: ['高德地图', '百度地图', '腾讯地图'],
    }
  },
  methods: {
    onConfirm(value) {
      this.value = value
      openMap(this.dhObj.longitude * 1, this.dhObj.latitude * 1, this.dhObj.parkingName, value)
      this.onCancel()
    },
    onCancel() {
      this.show = false
      this.$emit('onConfirm')
    },
  },
}
</script>

<style scoped lang="scss">
.Navigation {
  width: 100%;
}
</style>
